import React from 'react';
import StudentDecisionReport from './StudentDecisionReport';
export default function ManagementDashboard(){return <StudentDecisionReport mode="management"/>;}
